import React, { useEffect, useState } from "react";
import { Menu, X, Waves } from "lucide-react";
import { navLinks, RESERVE_URL } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-5 flex items-center justify-between rounded-full transition-all duration-300 ${
          scrolled ? "glass-strong py-2.5" : "py-2"
        }`}
      >
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center h-9 w-9 rounded-full border border-[#e8c874]/40 text-gold">
            <Waves className="h-4 w-4" />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-[15px] font-semibold tracking-wide text-white">
              École des Maîtres Dauphins
            </span>
            <span className="block text-[10px] tracking-[0.25em] uppercase text-aqua">
              Cursus Thérapeutes
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-white/75 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href={RESERVE_URL} target="_blank" rel="noreferrer"
             className="btn-gold px-5 py-2.5 text-sm inline-block">
            Je réserve ma place
          </a>
        </div>

        <button
          className="lg:hidden text-white p-1"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mx-4 mt-2 glass-strong rounded-2xl p-5">
          <nav className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-gold transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a href={RESERVE_URL} target="_blank" rel="noreferrer"
               className="btn-gold px-5 py-3 text-center mt-1">
              Je réserve ma place
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
